module.exports = __webpack_public_path__ + "static/media/timer-white-button.a49b9bde.png";